import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { Section } from '../Section';
import { NBSP } from '../../constants/symbols';

export const EscrowBlock = () => {
  return (
    <Section title="Безопасная сделка с эскроу-счётом" dataName="EscrowBlock">
      <UIText2>
        Деньги на{NBSP}стройку, в{NBSP}том числе ипотечные, надежно хранятся на{NBSP}специальном счете в{NBSP}банке,
        который покупатель открывает после заключения договора со{NBSP}строительной компанией. Подрядчик получит их
        {NBSP}только после завершения строительства и{NBSP}передачи готового дома заказчику. Если этого не{NBSP}
        произойдёт — покупатель получает деньги назад.
      </UIText2>
    </Section>
  );
};
